import { Reveal, Eyebrow } from "./AmberCallout";
import { CONTACT, CV_URL } from "../data";
import { Mail, Linkedin, Phone, MapPin, Download } from "lucide-react";

const rows = [
  {
    id: "email",
    icon: Mail,
    label: "Email",
    value: CONTACT.email,
    href: `mailto:${CONTACT.email}`,
    external: false,
  },
  {
    id: "linkedin",
    icon: Linkedin,
    label: "LinkedIn",
    value: CONTACT.linkedinLabel,
    href: CONTACT.linkedin,
    external: true,
  },
  {
    id: "phone",
    icon: Phone,
    label: "Phone",
    value: CONTACT.phone,
    href: `tel:${CONTACT.phone.replace(/\s/g, "")}`,
    external: false,
  },
  {
    id: "location",
    icon: MapPin,
    label: "Location",
    value: CONTACT.location,
    href: null,
    external: false,
  },
];

const Contact = () => (
  <section id="contact" data-testid="contact-section" className="py-20 sm:py-28 lg:py-32 bg-night text-parchment scroll-mt-20">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl">
        <Reveal>
          <Eyebrow>Contact</Eyebrow>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
            Let&rsquo;s connect for graduate opportunities.
          </h2>
          <p className="mt-6 text-base sm:text-lg text-parchment/70 leading-relaxed max-w-xl">
            {CONTACT.name} — currently open to graduate roles in consulting, project management,
            business analysis and advisory, in the UK and internationally.
          </p>
        </Reveal>

        <Reveal delay={0.1} className="mt-10">
          <ul className="divide-y divide-parchment/10 border-y border-parchment/10">
            {rows.map((row) => {
              const Icon = row.icon;
              const inner = (
                <>
                  <Icon className="w-4 h-4 text-terra shrink-0" aria-hidden="true" />
                  <span className="w-20 sm:w-24 text-xs font-mono uppercase tracking-wider text-parchment/50 shrink-0">
                    {row.label}
                  </span>
                  <span className="text-sm sm:text-base text-parchment group-hover:text-terra transition-colors duration-200 break-all">
                    {row.value}
                  </span>
                </>
              );
              return (
                <li key={row.id}>
                  {row.href ? (
                    <a
                      href={row.href}
                      data-testid={`contact-${row.id}-link`}
                      className="group flex items-center gap-4 py-4"
                      {...(row.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      {inner}
                    </a>
                  ) : (
                    <div data-testid={`contact-${row.id}-text`} className="flex items-center gap-4 py-4">
                      {inner}
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </Reveal>

        <Reveal delay={0.15} className="mt-10">
          <a
            href={CV_URL}
            download="Irene-Chen-CV.pdf"
            data-testid="contact-cta-download-cv"
            className="inline-flex items-center gap-2 bg-terra text-parchment font-sans font-medium text-sm sm:text-base rounded-full px-7 py-3.5 hover:bg-terrahover transition-colors duration-300"
          >
            <Download className="w-4 h-4" aria-hidden="true" />
            Download CV (PDF)
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Contact;
